// Custom components
import React from "react";

function InputField(props) {
  const { label, id, extra,labelExtra, type, placeholder, variant,value,onChange, state, disabled } =
    props;

  return (
    <div className={`${extra} text-gray-800`}>
      <label
        htmlFor={id}
        className={`text-sm  dark:text-white ${labelExtra} ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`mt-2 flex h-12 w-full items-center justify-center text-black rounded-xl border bg-white p-3 text-sm outline-none focus:border-2 focus:border-cyan-600 ${
          disabled === true
            ? "!border-none cursor-not-allowed !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 border-[3px] text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200  dark:text-gray-900"
        }`}
      />
    </div>
  );
}

export default InputField;
